import React from 'react';
import Icon from '../utils/icons';

export const skills = {
    'Flutter & Mobile': {
        icon: <Icon name="mobile" />,
        'Proficient': ['Flutter', 'Dart', 'BLoC', 'GetX', 'GoRouter', 'Dio', 'SQFLite', 'Firebase', 'Google Play', 'App Store', 'CodeMagic CI/CD', 'Figma', 'XCode'],
        'Familiar': ['Swift', 'Java (Android)']
    },
    'Web Development': {
        icon: <Icon name="globe" />,
        'Proficient': ['Next.js', 'Laravel', 'TypeScript', 'JavaScript', 'Vue.js', 'PHP', 'HTML/CSS', 'Tailwind CSS', 'Node.js', 'REST API', 'GraphQL'],
        'Familiar': ['React.js', '.NET Core', 'C#']
    },
    'Project Management': {
        icon: <Icon name="compass" />,
        'Proficient': ['Team Leadership', 'Agile / Scrum', 'ClickUp', 'Jira', 'Risk Analysis', 'Technical Specs'],
    },
    'Web3 & Blockchain': {
        icon: <Icon name="chain" />,
        'Proficient': ['SUI Network', 'Move Language', 'Smart Contracts', 'DeFi', 'NFT'],
        'Familiar': ['Solidity', 'Ethereum']
    },
    'Cloud & DevOps': {
        icon: <Icon name="cloud" />,
        'Proficient': ['AWS', 'Docker', 'Linux', 'Git / GitHub', 'GitLab', 'CI/CD', 'Vercel', 'Hetzner'],
    },
    'Database Management': {
        icon: <Icon name="database" />,
        'Proficient': ['MySQL', 'PostgreSQL', 'SQL Server', 'SQLite', 'MongoDB', 'Firebase Firestore', 'Supabase']
    }
};
